var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStateOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 22.6 22.6",
    viewBox: "0 0 22.6 22.6",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A5CE3A;}\n\t.st1{fill:none;stroke:#434343;stroke-miterlimit:10;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.3,
    cy: 11.3,
    r: 8.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11.3,
    cy: 11.3,
    r: 10.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStateOpen);
export default __webpack_public_path__ + "static/media/ic_state_open.46c8783fdbfdaafef52b0a5b9d675b37.svg";
export { ForwardRef as ReactComponent };